$(document).ready(function () {

  // Header
  // --------------------------------------------

  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".header__submenu").mouseleave(function (e) {
      $(this).parent().removeAttr("open");
    });
  }, function (e) {
    $(this).attr("open", false);
  });

  // Au survol d'un élément details dans la nav de class .header__inline-menu
  if ($(window).width() <= 749) {
    $(document).on('click', '.second_level', function () {
      var tabs = $(".second_level");
      var content = $(".last_submenu");
      $(this).toggleClass("open_menu");
      if (content.length) {
        $(this).parent("ul").find(tabs).not($(this)).removeClass("open_menu");
        $(tabs).not($(this)).parent("li").next("li").find(content).slideUp();
        $(this).parent("li").next("li").find(content).slideToggle();
      }
    });
  }

  // Footer
  // --------------------------------------------
  // Accordeon footer mobile
  if ($(window).width() <= 749) {

    $(document).on('click', '.footer_level_1 > li', function () {
      var title = $(".footer_level_1 > li");
      var content = $(".footer_level_2");
      $(this).find(".link_level_1").toggleClass("opened");
      if (content.length) {
        $(title).not($(this)).find(".link_level_1").removeClass("opened");
        $(title).not($(this)).find(content).slideUp();
        $(this).find(content).slideToggle();
      }
    });
  }


  // Homepage
  // --------------------------------------------
  // Section images : ouverture du lien au clic sur l'image
  if ($(".section-images .column, .section-medias .column").length) {
    $(document).on('click', '.section-images .column, .section-medias .column', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  if ($(".op").length) {
    $(document).on('click', '.op', function () {
      var redirect = $(this).data("target");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  if ($(".elx-banner").length) {
    $(document).on('click', '.elx-banner', function () {
      var redirect = $(this).data("target");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }
  if ($(".elx-images-list").length) {
    $(document).on('click', '.elx-images-list .grid__item', function () {
      var redirect = $(this).data("target");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  $(".search__input.field__input").on('input', function () {
   // si l'input est vide, on affiche les suggestions
    if ($(this).val() == "") {
      $(".suggestions_block").show();
    } else {
      $(".suggestions_block").hide();
    }
  });

    // Switch section liste de collections
    $(document).on('click', 'nav.collections_nav h2', function (event) {
        var $name = $(this).data("name");
        $("nav.collections_nav h2").removeClass("selected");
        $(this).addClass("selected");
        $(".section-collections-list .collection > slider-component").hide();
        $(".section-collections-list .collection > .collection__view-all").hide();
        $(".section-collections-list .collection > slider-component[data-target="+$name+"]").css("display", "block");
        $(".section-collections-list .collection > .collection__view-all[data-target="+$name+"]").css("display", "block");
      }
    );

  // PLP
  // --------------------------------------------

  // Au clic sur .mobile-facets__inner .icon-close on ferme le panneau de filtres
  $(document).on('click', '.mobile-facets__inner .icon-close', function () {
    $(".mobile-facets__close").trigger("click");
  });


  // Accordeon filtres mobile
  if ($(window).width() <= 749) {
    $(document).on('click', '.mobile-facets__details > .mobile-facets__summary', function () {
      var title = $(".mobile-facets__details > .mobile-facets__summary");
      var content = $(".mobile-facets__submenu");
      if (content.length) {
        $(title).not($(this)).next(content).slideUp();
        $(this).next(content).slideToggle();
      }
    });
  }

  // Redirection au clic sur l'image des cards
  $(document).on('click', '.card__media, .swiper-wrapper, .multicolumn-list__item', function () {
    var redirect = $(this).data("target");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Couleurs associées sur les products cards
  ellipsisOnColors();

  // Affichage des tailles des produits au survol du slider
  showProductSizes()

  // PDP
  // --------------------------------------------

  // Affichage des tailles dans le sticky si template correspondant
  resize();
  // Resize event
  $(window).resize(function (ev) {
    resize();
  });

  // Affichage des détails produits au clic sur les onglets
  if ($(".accordeon_product_details").length) {
    $(".tabs p").click(function (e) {
      var selected_tab = $(this).data("title");
      $(this).siblings("p").removeClass("selected");
      $(this).addClass("selected");
      $(this).parents(".accordeon_product_details").find(".tab").hide();
      $(this).parents(".accordeon_product_details").find("div[data-target='" + selected_tab + "']").show();
    });
  }

  // Fadeout le bloc de class fixed quand le scroll est en bas de la page
  $(document).on("scroll", function (e) {
    if ($('.footer__localization').isInViewport()) {
      $(".fixed").fadeOut();
    } else {
      $(".fixed").fadeIn();
    }
  });

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // Ouverture guide des tailles
  $(document).on('click', '#ProductPopup-traceability', function () {
    var src = $("#PopupModal-traceability iframe").data("src");
    $("#PopupModal-traceability iframe").attr("src", src);
  });

  // Ouverture guide des tailles
  $(document).on('click', '#sizing .close', function () {
    $("#sizing, #overlay").fadeOut();
  });

  $(document).on('click', '.sizing_btn', function () {
    $("#sizing, #overlay").fadeIn();
  });

  // Voir le look
  // Fermeture popin
  $(document).on('click', '.look .close', function () {
    $(".look").removeClass("active");
  });

  $(window).on('keyup', function () {
    $(".look").removeClass("active");
  });

  // Ouverture popin
  $(document).on('click', '.see_look', function () {
    $(".look").addClass("active");
  });

  $(document).on('click', '.section-stl .grid__item > img, .icon-plus', function () {
    if ($(window).width() >= 750) {
      var stl_img_height = $(this).siblings(".look").find(".img_look img").height();
      $(this).siblings(".look").css("top", 'calc(50% - ' + stl_img_height / 2 + 'px)');
      $(this).siblings(".look").find(".products_look").height(stl_img_height);
    }
    $(this).siblings(".look").addClass("active");
  });


  // Fermeture popin après ajout au panier
  $(document).on('click', '.look .quick-add__submit', function () {
    setTimeout(() => {
    $(".look").removeClass("active");
    }, 1000);
  });

  // position popin au scroll si bandeau d'annonce présent
  if ($(window).width() >= 750) {
    $(document).on("scroll", function (e) {
      if ($('.announcement-bar-section').length) {
        var menu_height = $(".section-header").innerHeight();
        if ($('.announcement-bar-section').isInViewport()) {
          $(".look:not(.look_stl").css("top", "unset");
        } else {
          $(".look:not(.look_stl").css("top", menu_height);
        }
      }
    });
  }

  if ($(window).width() > 749) {
    if ($('.announcement-bar-section').length) {
      searchModalPosition();
      $(document).on("scroll", function (e) {
        searchModalPosition();
      });
      $(document).on("click", ".close_announcement_bar", function (e) {
        $(".predictive-search").css("height", "90.5dvh");
      });
    }
  }

  function searchModalPosition() {
    if ($('.announcement-bar-section').isInViewport()) {
      $(".predictive-search").css("height", "88dvh");
    } else {
      $(".predictive-search").css("height", "90.5dvh");
    }
  }

  // Popin Omnicanal
  // Ouverture de la popin
  $('#omnicanal-toggle-1, #omnicanal-toggle-2').click(function (ev) {
    ev.preventDefault();

    // get iframe data-barcode attribute in a variable
    var barcode = $('#omnicanal-popin iframe').data("barcode");

    $("#omnicanal-popin iframe").attr("src", $('#omnicanal-popin iframe').data("src") + "&checked=" + barcode);

    $("#omnicanal-popin").fadeIn();
  });

  // Fermeture de la popin
  $('#omnicanal-popin').click(function (e) {
    if ($(e.target).attr("id") == "omnicanal-popin" || $(e.target).hasClass("close") || $(e.target).hasClass("icon")) {
      e.preventDefault();
      $("#omnicanal-popin").fadeOut();
    }
  });

  // FAQ
  // --------------------------------------------
  // Constitution de la liste des thèmes dans l'aside
  $(".faq_theme").each(function () {
    var faq = $(this).attr("id");
    var faq_name = $(this).find(".theme_title").html();
    $(".faq_page aside nav").append("<a data-name='" + faq.toLowerCase() + "'>" + faq_name + "</a>");
    $(".faq_page aside nav a:first-child").addClass("selected");
  });

  // Souligner le thème sélectionné + apparition de la section de questions associée
  $("aside nav a").click(function (e) {
    $("aside nav a").removeClass("selected");
    $(this).addClass("selected");

    $name = $(this).data("name");
    $(".faq_theme").parent(".faq_section").hide();
    $("#" + $name + ".faq_theme").parent(".faq_section").fadeIn(400);
  });

  // Ouverture des questions au clic sur le titre
  $(".faq_list h3, .accordeon_blocks h3").click(function (e) {
    var questions = $(".faq_list h3, .accordeon_blocks h3");
    var answers = $(".faq_list > div, .accordeon_blocks > div");
    $(this).toggleClass("opened");
    if (answers.length) {
      $(questions).not($(this)).removeClass("opened");
      $(questions).not($(this)).next(answers).slideUp();
      $(this).next("div").slideToggle();
    }
  });

  // Accordeon sur CGV et page entretien
  // --------------------------------------------

  // Ancres vers les onglets au clic dans la liste des onglets + ancre vers l'onglet
  $(".accordeon_titles a").click(function (e) {
    $name = $(this).data("name");
    $this = $("h3#" + $name);
    $this_height = $("h3#" + $name).next("div").innerHeight();

    $this.toggleClass("opened");
    $this.next("div").slideToggle();
    $(".accordeon_theme").not($this).removeClass("opened");
    $(".accordeon_theme").not($this).next("div").slideUp(200);

    setTimeout(function () {
      // scroll to the top of the h3 with the id $name
      var offset = $("#" + $name).offset().top - 40;
      $("html, body.body-accordeon").animate({ scrollTop: offset });
    }, 300);
  });

  // Page boutique
  // --------------------------------------------

  if ($(".store_features").length) {
    if ($(window).width() >= 750) {
      // Ouverture des onglets détails de la boutique
      $(".tabs p").click(function (e) {
        $(".tabs p").removeClass("selected");
        $(this).addClass("selected");
        $name = $(this).data("name");

        $(".tab").hide();
        $(".tab[data-target='" + $name + "']").fadeIn(400);
      });
    }
  }

  // Page Panier
  // --------------------------------------------

  // Messages cadeaux
  if ($("#checkbox_message").length) {
    $(document).on('change', '#checkbox_message', function () {
      $('#gift_message_1').val('');
      $('#gift_message_2').val('');
      $('#gift_message_3').val('');
      $('#gift_message_4').val('');
      $('#gift_message_5').val('');

      if ($(this).is(":checked")) {
        $(".gift_message_fields").show();
      } else {
        $(".gift_message_fields").hide();
      }
    });
  }

  // Barre d'annonce
  // --------------------------------------------
  // Click sur le bouton de fermeture de la barre
  $('.close_announcement_bar').click(function (e) {
    e.preventDefault();

    // Transition de fermeture
    $('.announcement-bar-section').slideUp(150, function () {
      $(this).remove();
    })

    // On stocke en session la demande de fermeture
    sessionStorage.setItem("closed_announcement", "true");
  });

  // Pages quick links
  // --------------------------------------------

  if ($("body.template_page .quick_links_section").length) {
    $("main").css("margin-top", "0");
  }

  // Swiper init card product + product page
  initSwipers();

  // Connexion compte
  // --------------------------------------------
  $('input#CustomerEmail').keypress(function (e) {
    if (e.which == 13) { // Code 13 correspond à la touche "Entrée"
      e.preventDefault(); // Empêche la soumission du formulaire
      var inputs = $('input'); // Sélectionne tous les champs input
      var index = inputs.index(this); // Trouve l'index du champ actuel
      if (index < inputs.length - 1) {
          inputs.eq(index + 1).focus(); // Déplace le focus au champ suivant
      }
    }
  });

});

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: false });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
observeDOM(document.getElementById("product-grid"), function (m) {
  initSwipersLazy();
  showProductSizes();
  ellipsisOnColors();
});

function initSwipers() {
  var $target = $(".mySwiper").not(".swiper-initialized");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      new Swiper($(this).get(0), {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        }
      });
    });
  }

  if ($(".product_swiper").length && $(window).width() < 750) {
    var swiper_product = new Swiper(".product_swiper", {
      loop: true,
      centeredSlides: true,
      spaceBetween: 8,
      slidesPerView: "auto"
    });
    swiper_product.slideToLoop(0, 0);
  }
}

function initSwipersLazy() {
  var $target = $(".mySwiper").not(".swiper-initialized");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $that = $(this);
      $(this).find("img").first().on("load", function () {
        new Swiper($that.get(0), {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          }
        });
      });
    });
  }
}

function showProductSizes() {
  $(".grid__item .card__inner").hover(function (e) {
    if ($(this).next(".card__content").find(".product_variants").length) {
      $(this).next(".card__content").find(".associated_products").css("opacity", "0");
      $(this).next(".card__content").find(".product_variants:not(.no_associated_products)").css("opacity", "1");
    }
  }, function (e) {
    $(this).next(".card__content").find(".associated_products").css("opacity", "1");
    $(this).next(".card__content").find(".product_variants:not(.no_associated_products)").css("opacity", "0");
  });
}

function ellipsisOnColors() {
  $(".product_variants:not(.no_associated_products)").each(function () {
    if ($(this)[0].clientWidth < $(this)[0].scrollWidth) {
      $(this).addClass("more_colors");
    }
  });
}

function resize() {
  if ($(".fixed.bundle").length) {
    if ($(window).width() <= 750) {
      var $radios = $(".fixed.bundle variant-radios");
      $radios.detach().insertBefore(".accordeon_product_details").addClass("bundle_radios");
    } else {
      var $radios = $("variant-radios");
      $radios.detach().insertAfter(".fixed.bundle .form_hide").removeClass("bundle_radios");
    }
  }
}

